import { Plus } from "lucide-react";

import { useAddDevice } from "@/hooks/use-add-device";
import { Button, type ButtonProps } from "@/components/ui/button";

interface DownloadAppButtonProps {
  onDeviceConnected?: () => void;
  size?: ButtonProps["size"];
}

export function DownloadAppButton({
  onDeviceConnected,
  size = "sm",
}: DownloadAppButtonProps) {
  const { addDevice, isReady } = useAddDevice({ onDeviceConnected });

  return (
    <Button
      type="button"
      size={size}
      onClick={addDevice}
      // Disabled until the user query resolves: without a userId the click
      // handler silently no-ops, so a hard reload of this page (cache not yet
      // warmed) would otherwise render a dead-looking "Add Device" button.
      disabled={!isReady}
    >
      <Plus />
      Add Device
    </Button>
  );
}
